import chttp from '@/libs/base/coupon_http';
import apis from '@/libs/base/apis';

const gift = {
  state: {
    giftShow: false,
    gzhCode: '',
  },
  mutations: {
    SHOW_GIFT_CONTROL(state, show) {
      state.giftShow = show;
    },
    GET_GAH_CODE(state, data) {
      state.gzhCode = data;
    },
  },
  actions: {
    async GET_GAH_MATCH({ commit, rootState }, data) {
      const params = {
        openid: rootState.openid,
        unionid: rootState.unionid,
      };
      const res = await chttp.get(apis.getGzhMatch, { params });
      if (res.errcode === 21001) {
        commit('GET_GAH_CODE', res.qr);
      } else if (res.errcode === 10002) {
        commit('GET_GAH_CODE', null);
      }
      if (data.callback) {
        data.callback();
      }
    },
  },
};

export default gift;
